import { BaseFiltroPaginate } from "resources/enums/paginate";
import { useCallback, useState } from "react";
import { ImpostoQueryParams } from "core/features/Imposto/typings/index";

function useFiltroImpostos() {
  const [filtro, setFiltro] = useState<ImpostoQueryParams>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
  });

  const onChangeFiltro = useCallback((_filtro: Partial<ImpostoQueryParams>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroImpostos;
